// Polyfills and other libraries required before execution
import URLSearchParams from '@ungap/url-search-params';

window.URLSearchParams = URLSearchParams;
